export class ordersData {
  
    constructor(
      public uname: string,
      public passw: string,
      public uid: string,
      public umail: string,
      public orders: Object
    ) {  }
  
  }
  


// WEBPACK FOOTER //
// ./src/app/create-workspace/http-post-request-object-classes/ordersData.ts